module.exports = __webpack_public_path__ + "assets/img/2-f44115b1.jpg";